import React from 'react';
import {observer} from 'mobx-react';
import {MATCH_EVENTS} from "../../match-events-widget.consts";
import {EntityLogo, EntityLogoProps} from "../../../../../../core/components/logos/entity-logo";
import styles from "../../styles/match-event.module.scss";
import classNames from "classnames";

export const MatchEventsModuleEventImages = observer(({event, swapDirection}) => {
  const {player, eventType, extraPlayers} = event;
  const isSubstitutionEvent: Boolean = eventType.id === MATCH_EVENTS.EVENT_TYPES.substitution;
  const containerClassName = classNames(styles.event_image, {[styles.event_image_swap_direction]: swapDirection},
    {[styles.event_image_substitution]: isSubstitutionEvent});
  const subsClassName: String = swapDirection ? styles.event_image_away_sub_out_logo : styles.event_image_home_sub_out_logo

  const athleteLogoProps: EntityLogoProps = {
    entity: player,
    width: 35,
    height: 35
  };

  const extraAthleteLogoProps: EntityLogoProps = isSubstitutionEvent && {
    entity: extraPlayers[0],
    width: 35,
    height: 35
  };

  return (
    <div className={containerClassName}>
      <div className={classNames(styles.event_image_logo, {[styles.event_image_sub_in_logo]: isSubstitutionEvent})}>
        <EntityLogo {...athleteLogoProps}/>
      </div>
      {
        isSubstitutionEvent ? <div className={classNames(styles.event_image_logo, subsClassName,
          {[styles.event_image_sub_out_logo]: isSubstitutionEvent})}>
          <EntityLogo {...extraAthleteLogoProps}/>
        </div> : null
      }
    </div>
  )
});
